import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '@/lib/auth/entra/msal';

/**
 * Manager SSO trigger. Redirects to Entra; on return MSAL's redirect handler
 * (in main.tsx via msalReady) sets the active account, and we forward to /dashboard.
 */
export function ManagerSignIn() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center gap-6 p-6 bg-background">
      <div className="flex flex-col items-center gap-6 rounded-2xl border border-border bg-card px-10 py-12 shadow-sm">
        <img src="/brand/qargo-navy.png" alt="Qargo Coffee" className="w-40 max-w-full" />
        <h2 className="text-2xl font-semibold text-brand-navy">Manager sign-in</h2>
        <button
          type="button"
          onClick={() => {
            void instance.loginRedirect(loginRequest);
          }}
          disabled={inProgress !== 'none'}
          className="px-6 py-3 rounded-lg bg-primary text-primary-foreground font-medium shadow hover:opacity-90 disabled:opacity-60"
        >
          Sign in with Microsoft
        </button>
      </div>
      <img src="/brand/tmkn.png" alt="TMKN" className="h-6 opacity-70 absolute bottom-8" />
    </div>
  );
}
